module.exports = __webpack_public_path__ + "static/media/smile-active.967cf73d.svg";